import React from 'react';
import './OpenHours.css';

const dailyHours = [
  {
    day: 'Monday',
    open: '11:00',
    close: '21:00',
    badges: [
      { type: 'happy-hour', label: 'Happy Hour', start: '14:00', end: '17:30' },
    ],
  },
  {
    day: 'Tuesday',
    open: '11:00',
    close: '21:00',
    badges: [
      { type: 'happy-hour', label: 'Happy Hour', start: '14:00', end: '17:30' },
    ],
  },
  {
    day: 'Wednesday',
    open: '11:00',
    close: '21:00',
    badges: [
      { type: 'happy-hour', label: 'Happy Hour', start: '14:00', end: '17:30' },
    ],
  },
  {
    day: 'Thursday',
    open: '11:00',
    close: '21:00',
    badges: [
      { type: 'happy-hour', label: 'Happy Hour', start: '14:00', end: '17:30' },
    ],
  },
  {
    day: 'Friday',
    open: '11:00',
    close: '23:30',
    badges: [
      { type: 'happy-hour', label: 'Happy Hour', start: '14:00', end: '17:30' },
      { type: 'late-night', label: 'Late Night Happy Hour', start: '20:00', end: '23:00' },
    ],
  },
  {
    day: 'Saturday',
    open: '10:00',
    close: '23:30',
    badges: [
      { type: 'late-night', label: 'Late Night Happy Hour', start: '20:00', end: '23:00' },
    ],
  },
  {
    day: 'Sunday',
    open: '10:00',
    close: '21:00',
    badges: [],
  },
];

const formatTime = (time24) => {
  if (!time24) return '';
  const [hourStr, minuteStr = '00'] = time24.split(':');
  let hours = parseInt(hourStr, 10);
  const minutes = minuteStr.padStart(2, '0');
  const period = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;
  return `${hours}:${minutes} ${period}`;
};

const OpenHours = () => {
  return (
    <div className="open-hours">
      <h2 className="hours-title">Open Hours</h2>
      <div className="hours-grid">
        {dailyHours.map(({ day, open, close, badges }) => (
          <div className="hours-section" key={day}>
            <h3>{day}</h3>
            <p>{`${formatTime(open)} - ${formatTime(close)}`}</p>
            {badges.map((badge, index) => (
              <span
                key={`${day}-${badge.label}-${index}`}
                className={`hours-badge ${badge.type}`}
              >
                {badge.label} {`${formatTime(badge.start)} - ${formatTime(badge.end)}`}
              </span>
            ))}
          </div>
        ))}
      </div>
      
      <div className="trivia-section">
        <h3 className="trivia-title">Join Us for Trivia Nights!</h3>
        <p className="trivia-description">Test your knowledge and have fun with friends at our exciting trivia nights!</p>
        <a 
          href="https://dangit.media/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className="trivia-button"
        >
          More Details About Trivia Nights
        </a>
      </div>
    </div>
  );
};

export default OpenHours; 